import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import messages from './messages';
import { useHasUnsupportedActions } from './unsupported-rule-banner';
import { FilterEditorContext } from '../../../../../components/filter-editor/context';
import { AutomationRulesContext } from '../../context';

export const SaveButton = () => {
  const { saveAutomationRule, selectedRule, setSelectedRule, setIsDrawerOpen, setIsDrawerLoading, ruleName } =
    useContext(AutomationRulesContext);
  const { saveFilterSet, filterSets, setShouldFetchFilters } = useContext(FilterEditorContext);
  const hasUnsupportedActions = useHasUnsupportedActions();
  const onSuccess = useCallback(() => {
    setIsDrawerOpen(false);
  }, [setIsDrawerOpen]);
  const onSave = useCallback(() => {
    const { filterId } = selectedRule;
    const filter = filterSets[filterId ?? ''];
    const isAdhocFilter = filter && !filter.active;
    setIsDrawerLoading(true);
    if (isAdhocFilter) {
      saveFilterSet((orderFilterSetId: string) => {
        const ruleProps = {
          ...selectedRule,
          filterId: orderFilterSetId,
        };
        setShouldFetchFilters(true);
        setSelectedRule(ruleProps);
        saveAutomationRule(orderFilterSetId, onSuccess);
      });
      return;
    }
    saveAutomationRule(filterId != null ? String(filterId) : undefined, onSuccess);
  }, [saveAutomationRule, saveFilterSet, selectedRule, setSelectedRule, filterSets, onSuccess, setIsDrawerLoading, setShouldFetchFilters]);

  const isDisabled = (ruleName?.length ?? 0) <= 0 || hasUnsupportedActions(selectedRule);

  return (
    <Button disabled={isDisabled} onClick={onSave} theme='primary'>
      <FormattedMessage {...messages.ruleEditorSave} />
    </Button>
  );
};
